import {
  DEFAULT_ADMIN_PAGE,
  DEFAULT_EMPLOYEE_PAGE,
  DEFAULT_SECURITY_PAGE,
  DEFAULT_SUPPORT_PAGE,
} from '../constants/app-router';
import { Nullable } from '../constants/types';
import { BadgeType, UserFunction, USER_ROLE } from '../enum/role.enum';
import { Allowance } from './allowance.model';
import { Parking } from './parking.model';

export class EmployeeRole {
  public isAdmin: boolean = false;
  public isSupport: boolean = false;
  public isSecurity: boolean = false;
}

export class UserInfo {
  public id: string = '';
  public fullName: string = '';
  public badgeType: string = '';
  public employeeNb: number = 0;
  public function: Nullable<UserFunction> = null;
  public userRights: Nullable<EmployeeRole> = null;
  public homebase: string = '';
  public homebaseSettingValues: (Parking | Allowance)[] = [];
  public isDevUser? : boolean;

  constructor(user: Partial<UserInfo>) {
    Object.assign(this, user);
    this.homebaseSettingValues =
      user.homebaseSettingValues?.map(v => {
        if (v.variableName?.toLowerCase().includes('parking')) {
          return new Parking(v);
        } else {
          return new Allowance(v);
        }
      }) || [];
  }

  public get isInternal(): boolean {
    return this.badgeType == BadgeType.INTERNAL;
  }

  public get isEb(): boolean {
    return this.function == UserFunction.EB;
  }

  public get isBoard(): boolean {
    return this.function == UserFunction.BOARD;
  }

  public hasAccess(role: USER_ROLE): boolean {
    if (role == USER_ROLE.ADMIN && this.userRights?.isAdmin) {
      return true;
    }
    if (role == USER_ROLE.SECURITY && this.userRights?.isSecurity) {
      return true;
    }
    if (role == USER_ROLE.FUNCTIONAL_SUPPORT && this.userRights?.isSupport) {
      return true;
    }
    if (role == USER_ROLE.EMPLOYEE) {
      return true;
    }

    return false;
  }

  public get defaultPage(): string {
    if (this.userRights?.isAdmin) {
      return DEFAULT_ADMIN_PAGE;
    }
    if (this.userRights?.isSecurity) {
      return DEFAULT_SECURITY_PAGE;
    }
    if (this.userRights?.isSupport) {
      return DEFAULT_SUPPORT_PAGE;
    }

    return DEFAULT_EMPLOYEE_PAGE;
  }
}
